import { Variant } from 'shared/types/product';
import { Product, SizeGuide } from 'shared/types/product/Product';
import { UIColor, UIProduct, UISize } from 'components/commercetools-ui/organisms/product/product-details/types';

export const toUIProduct = (product: Product, variant: Variant, colors: UIColor[], sizes: UISize[]) => {
  const mappedProduct: UIProduct = {
    version: product?.version,
    productKey: product?.productKey,
    productId: product?.productId,
    name: product?.name ?? '',
    slug: product?.slug ?? '',
    variants: product?.variants,
    price: variant?.price ?? {},
    categories: product?.categories,
    discountTextInfo: product?.discountTextInfo,
    customFitDetails: product?.customFitDetails,
    customFitAttributeDetails: product?.customFitAttributeDetails,
    productDiscount: product?.productDiscount,
    currentSeasonCode: product?.currentSeasonCode,
    p1BadgeData: product?.p1BadgeData,
    p2BadgeData: product?.p2BadgeData,
    personalisation: product?.personalisation,
    productAttributes: product?.productAttributes,
    brandLogo: product?.brandLogo,
    sizeGuide: product?.sizeGuide,
    paymentPromotion: product?.paymentPromotion,
    images:
      variant?.images?.map((img: string, id: number) => ({
        id: `${variant?.sku}-${id}`,
        src: img,
        alt: variant?.sku,
      })) ?? [],
    colors,
    sizes,
    description: `
          <p>${product?.description || ''}</p>
        `,

    details: [
      {
        name: 'Features',
        items: [
          variant?.attributes?.designer && `Designer: ${variant?.attributes.designer.label}`,
          variant?.attributes?.gender && `Collection: ${variant?.attributes.gender.label}`,
          variant?.attributes?.madeInItaly && `Made in Italy`,
        ],
      },
    ],
    breadCrumb: product?.breadCrumb ?? [],
    breadCrumbList: product?.breadCrumbList ?? [],
    modifiedAt: product?.modifiedAt,
    published: product?.published,
    popupData: product?.popupData,
    firstReceiptDate: product?.firstReceiptDate,
  };

  return mappedProduct;
};
